<template>
  <div
    class="pin-input"
    :class="[fields === 4 ? 'pin-input--small' : 'pin-input--big']"
  >
    <div
      class="pin-input__field-group"
      v-for="(n, index) in fields"
      :key="index"
    >
      <input
        :type="isVisible ? 'text' : 'password'"
        name="n1"
        :id="name + (index + 1)"
        :ref="name + index"
        @input="saveValue($event, index)"
        @keyup="handleBackspace($event, index)"
        @keypress="isNumber($event)"
        @paste="handlePaste($event)"
        class="pin-input__field"
        :v-model="name + (index + 1)"
        maxlength="1"
      />
      <div class="pin-input__separator" v-if="index !== fields - 1"></div>
    </div>
  </div>
</template>
<script>
  import { isNumber } from "@/utils/helpers";
  export default {
    name: "PinView",
    data() {
      return {
        pin: "",
        backspaceTriggered: false,
      };
    },
    props: {
      fields: {
        type: Number,
        required: true,
      },
      clearPin: {
        type: Boolean,
        required: true,
      },
      name: {
        type: String,
        required: false,
        default: "Pin",
      },
      isVisible: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    watch: {
      pin: function (value) {
        if (!this.backspaceTriggered) {
          this.handleBackspace();
        }
      },
      clearPin: function (value) {
        if (value) {
          for (let index = 0; index < this.fields; index++) {
            const input = this.$refs[this.name + index][0];
            input.value = "";
            this.pin += input.value;
          }
        }
      },
    },
    emits: ["value-change"],
    methods: {
      isNumber,
      saveValue(e, i) {
        const target = e.target;
        const value = target.value;
        const id = target.id;
        // check if the current input field has more than one character and is not the last field
        if (e.inputType !== "deleteContentBackward") {
          if (value.length > 1 && i + 1 < this.fields) {
            // assign the last character of the current input field as the only value
            target.value = value[1];
            // check if an input has more than one character and is the last field
          } else if (value.length > 1 && i + 1 === this.fields) {
            // assign the most recent character as the only character in it
            target.value = value[1];
          }
          let pin = this.pin;
          // check if the value of pin is greater than fields
          if (pin.length >= this.fields) {
            // convert pin string to array
            pin = [...pin];
            // replace current index in pin with new value from input field
            pin.splice(i, 1, target.value);
            // convert back to string
            pin = pin.join("");
          } else {
            pin += target.value;
          }
          this.pin = pin;
          // check that there is a next field and focus on it.
          if (i + 1 < this.fields && value) {
            const nextElement = this.$refs[id][0];
            nextElement.focus();
          }
        }
      },
      handlePaste(e) {
        // prevent copied value from being pasted
        e.preventDefault();
        // get pasted value
        const paste = e.clipboardData.getData("text");
        const fields = this.fields;

        // set field to empty
        this.pin = "";
        // loop over each input, and populate with the index of that string
        for (let index = 0; index < fields; index++) {
          const input = this.$refs[this.name + index][0];
          input.value = paste[index];
          this.pin += input.value;
        }
      },
      emitChange() {
        this.$emit("value-change", this.pin);
      },
      handleBackspace(e, i) {
        const keyCode = e ? e.code : null;
        const pinArray = [...this.pin];
        if (keyCode === "Backspace") {
          this.backspaceTriggered = true;
          pinArray.splice(i, 1);
          if (i !== 0) {
            this.reArrangePin(pinArray);
            this.pin = pinArray.join("");
            const previousElement = this.$refs[this.name + (i - 1)][0];
            previousElement.focus();
          } else {
            this.reArrangePin(pinArray);
            this.pin = pinArray.join("");
          }
        }
        this.emitChange();
      },
      reArrangePin(pinArray) {
        for (let index = 0; index < this.fields; index++) {
          if (pinArray[index]) {
            this.$refs[this.name + index][0].value = pinArray[index];
          } else {
            this.$refs[this.name + index][0].value = "";
          }
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
.pin-input {
  display: flex;
  justify-content: center;
  gap: 8px;
  max-width: 320px;
  margin: 0 auto;

  &--small {
    max-width: 280px;
  }

  &--big {
    max-width: 320px;
  }

  &__field-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__field {
    width: 48px;
    height: 52px;
    border: 1px solid #E2E8F0;
    border-radius: 10px;
    background: #F8FAFC;
    font-family: 'DM Sans', sans-serif;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #0F172A;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: #4D84FF;
      background: white;
      box-shadow: 0 0 0 3px rgba(77, 132, 255, 0.1);
    }
  }

  &__separator {
    width: 8px;
    height: 2px;
    background: #E2E8F0;
    border-radius: 1px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
